@let sideBarItems = this.sideBarItems();
<div class="sidebar" [class.is-collapsed]="!showNav()">
  <div class="sidebar--header">
    <button
      type="button"
      class="sidebar--header--icon"
      (click)="toggleShowNav()"
      [title]="showNav() ? 'Collapse' : 'Expand'"
      [attr.aria-label]="showNav() ? 'Collapse navigation' : 'Expand navigation'"
      >
      <span class="material-symbols-outlined" aria-hidden="true"> dock_to_right </span>
    </button>
    <div
      class="sidebar--header--title prevent-select"
      (click)="navigateToHomePage()"
      >
      FridayTech
    </div>
  </div>
  <div class="sidebar--content">
    @for (item of sideBarItems; track item.id) {
      @if (isGroupStart($index)) {
        <div class="sidebar-group" [attr.aria-label]="groupLabel(item)">
          <span class="sidebar-group--label">{{ groupLabel(item) }}</span>
          <span class="sidebar-group--rule" aria-hidden="true"></span>
        </div>
      }
      <button
        type="button"
        class="sidebar-item"
        [class.item-selected]="isSelected(item)"
        [attr.aria-current]="isSelected(item) ? 'page' : null"
        [title]="showNav() ? '' : item.name"
        (click)="selectSideBarItem(item)"
        >
        <span class="sidebar-item--icon material-symbols-outlined" aria-hidden="true">
          {{ item.googleIcon }}
        </span>
        <div class="sidebar-item--label">
          {{ item.name }}
        </div>
      </button>
    }
  </div>
  <div class="sidebar--footer">
    @if (userName) {
      @if (myAccount) {
        <!-- the name is the way into My account: your own login and password (docs/ui/my-account.md §2) -->
        <button type="button" class="sidebar--user sidebar--user-link" (click)="openMyAccount()" title="My account">
          <div class="sidebar--user-name">{{ userName }}</div>
          @if (userRole) { <div class="sidebar--user-roles">{{ userRole }}</div> }
        </button>
      } @else {
        <div class="sidebar--user" [title]="userRole">
          <div class="sidebar--user-name">{{ userName }}</div>
          @if (userRole) { <div class="sidebar--user-roles">{{ userRole }}</div> }
        </div>
      }
    }
    <button type="button" class="sidebar--logout" (click)="logOut()" title="Log out">
      <span class="sidebar-item--icon material-symbols-outlined" aria-hidden="true">logout</span>
      <div class="sidebar-item--label">Log out</div>
    </button>
  </div>
</div>
